/**
 * CommandFlowOrchestrator - Handles high-level command flow coordination
 */
export class CommandFlowOrchestrator {
  constructor(sessionManager, redirectHandler, inputHandler) {
    this.sessionManager = sessionManager;
    this.redirectHandler = redirectHandler;
    this.inputHandler = inputHandler;
  }

  /**
   * Handle command completion flow
   */
  async handleCommandCompletion(
    step,
    sessionData,
    input,
    stepOutput,
    callbacks = {}
  ) {
    console.log("🔍 Checking for redirect on command completion...");

    // Store command reference for completion processing
    sessionData._command = this.sessionManager.session.command;

    const completionResult = await this.redirectHandler.handleCompletion(
      step,
      sessionData,
      input,
      stepOutput,
      callbacks
    );

    // Handle redirect vs direct command start
    if (completionResult.startCommand) {
      return {
        type: "startCommand",
        target: completionResult.startCommand.target,
        data: completionResult.startCommand.data,
      };
    }

    // Handle redirect with output (nextCommand format)
    if (completionResult.nextCommand) {
      return {
        type: "redirect",
        result: completionResult,
      };
    }

    return {
      type: "completion",
      result: completionResult,
    };
  }

  /**
   * Handle mid-step flow coordination
   */
  async handleMidStepFlow(step, sessionData, input, stepOutput, callbacks) {
    // Check for mid-step redirects
    const redirectResult = await this.redirectHandler.handleMidStepRedirect(
      step,
      input,
      sessionData,
      stepOutput,
      callbacks
    );

    if (redirectResult) {
      if (redirectResult.startCommand) {
        return {
          type: "startCommand",
          target: redirectResult.startCommand.target,
          data: redirectResult.startCommand.data,
        };
      }

      return {
        type: "redirect",
        result: redirectResult,
      };
    }

    // Continue to next step
    return {
      type: "nextStep",
      stepOutput,
    };
  }

  /**
   * Process user input through the flow
   */
  async processUserInput(
    input,
    currentStep,
    sessionData,
    callbacks,
    promptResolver
  ) {
    // Process user input
    const inputResult = await this.inputHandler.processInput(
      input,
      currentStep,
      sessionData,
      callbacks
    );

    if (inputResult.validationError) {
      const errorResult = await this.inputHandler.handleValidationError(
        inputResult.validationError,
        currentStep,
        sessionData,
        promptResolver
      );
      return {
        type: "validationError",
        result: errorResult,
      };
    }

    return {
      type: "inputProcessed",
      stepOutput: inputResult.stepOutput,
    };
  }
}
